module.exports = __webpack_public_path__ + "img/delete-not-used-codes.201d0a75.svg";